import useAppCtx from "../../../app/ctx-provider/useAppCtx";

const useAgenturKontakt = () => {
    const { appCtxBo, setAppCtxBo } = useAppCtx();

    const changeVisibleState = () => {
        appCtxBo.renderMainKontakt = !appCtxBo.renderMainKontakt;
        setAppCtxBo(appCtxBo);
    }

    return {
        changeVisibleState,
        renderMainKontakt: appCtxBo.renderMainKontakt
    }
}

export default useAgenturKontakt;